import { createRef } from "react";
export var defaultContext = {
  isDark: false,
  source: '',
  designMode: undefined,
  sectionRef: /*#__PURE__*/createRef(),
  currentRoute: undefined,
  scrollTop: function scrollTop() {},
  openSideBar: function openSideBar() {},
  closeSideBar: function closeSideBar() {},
  onRouteChange: function onRouteChange() {},
  toggleSideBar: function toggleSideBar() {},
  toggleDesignMode: function toggleDesignMode() {},
  openErrorSnackbar: function openErrorSnackbar() {},
  updateCurrentRoute: function updateCurrentRoute() {},
  toggleMobileSideBar: function toggleMobileSideBar() {}
};